/**
 * Created by Jerker Nord on 2021-08-26.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGritStatics} from "../TrueGritStatics";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TrueGrit} from "../TrueGrit";
import {gsap} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {TrueGritGameMode} from "../server/TrueGritGameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {IWinRatioConfig, TrueGritWinConfigs} from "../configs/TrueGritWinConfigs";

export class TrueGritTotalWinView extends PIXI.Container implements StageLayer {

    private _totalWinCountUp:BasicBitmapCountUp;
    private _totalWinContainer:PIXI.Container;
    private _totalWaysWonText:PIXI.BitmapText;
    private _wayText:PIXI.Sprite;
    private _waysText:PIXI.Sprite;
    private _waysContainer:PIXI.Container;
    private _fadeInTimeline:gsap.core.Timeline;
    private _fadeOutTimeline:gsap.core.Timeline;
    private _countUpTimeline:gsap.core.Timeline;
    private _totalWinAmount:number;
    private _winRatioConfig:IWinRatioConfig;
    private _completeCallback:Function;
    private _playSound:boolean = true;
    private _endSoundPlayed:boolean;
    private _targetScale:number;
    private _isWinBelowStake:boolean = false;

    private static FADE_IN_TIME:number = 0.3;

    constructor() {
        super();
        this.name = "TrueGritTotalWinView";
        this.init();
    }

    private init() {
        this._totalWinContainer = new PIXI.Container();
        this._totalWinContainer.position.set(360, 360);
        this.addChild(this._totalWinContainer);

        this._totalWinCountUp = new BasicBitmapCountUp({
            fontName : TrueGritGameAssets.BITMAP_FONT_WIN_NUMBERS,
            fontSize : 190,
            tint : 0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp.visible = false;
        this._totalWinCountUp.position.y = 50;
        this._totalWinContainer.addChild(this._totalWinCountUp);

        this._waysContainer = new PIXI.Container();
        this._waysContainer.position.set(360, 420);
        this.addChild(this._waysContainer);
        this._totalWaysWonText = new PIXI.BitmapText("", {
            fontName : TrueGritGameAssets.BITMAP_FONT_NUMBERS_WAYS_WON,
            fontSize : 59
        });
        this._totalWaysWonText.position.set(0, 0);
        this._totalWaysWonText.visible = false;
        this._waysContainer.addChild(this._totalWaysWonText);
        this._wayText = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.WAY_WON_TEXT)[0]);
        this._wayText.visible = false;
        this._waysContainer.addChild(this._wayText);
        this._waysText = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.WAYS_WON_TEXT)[0]);
        this._waysText.visible = false;
        this._waysContainer.addChild(this._waysText);

        if (TrueGrit.model.isRestore) {
            if (TrueGritTotalWinView.checkMode() || TrueGritTotalWinView.checkNextMode()) {
                TrueGrit.keypadPlugin.setWin(TrueGrit.model.initData.accumulatedRoundWin, true, TrueGrit.isWinBelowStake());
            }
        }

        this.onResize();
    }

    private static checkMode(): boolean {
        return (TrueGrit.model.data.mode == TrueGritGameMode.NORMAL_AVALANCHE || TrueGrit.model.data.mode == TrueGritGameMode.FREESPIN || TrueGrit.model.data.mode == TrueGritGameMode.FREESPIN_AVALANCHE
            || TrueGrit.model.data.mode == TrueGritGameMode.FREESPIN_SUPER || TrueGrit.model.data.mode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE);
    }

    private static checkNextMode(): boolean {
        return (TrueGrit.model.data.nextMode == TrueGritGameMode.NORMAL_AVALANCHE || TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN || TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_AVALANCHE
            || TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_SUPER || TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE);
    }

    onResize():void {
        this.position = TrueGritStatics.TOTAL_WIN_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public getTotalWinTimeline(totalWin:number, waysWon:number, completeCallback:Function):gsap.core.Timeline {
        if (this._fadeOutTimeline && this._fadeOutTimeline.isActive()) {
            this._fadeOutTimeline.pause();
            this._fadeOutTimeline.kill();
        }

        this._isWinBelowStake = TrueGrit.isWinBelowStake();
        this._totalWinAmount = totalWin;
        this._winRatioConfig = TrueGritWinConfigs.getWinRatioConfig();
        this._completeCallback = completeCallback;
        this._playSound = true;

        this._totalWinCountUp.scale.set(0.5,0.5);
        let targetScale = 0.5;
        if (this._winRatioConfig.type == TrueGritWinConfigs.SMALL){
            targetScale = 0.6;
        } else if (this._winRatioConfig.type == TrueGritWinConfigs.MEDIUM){
            targetScale = 0.7;
        } else if (this._winRatioConfig.type == TrueGritWinConfigs.LARGE){
            targetScale = 0.8;
        }
        this._targetScale = targetScale;

        // #506
        this._totalWinCountUp.visible = true;
        this._waysContainer.visible = true;
        if(TrueGrit.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && TrueGrit.model.winRatio <= 1) {
            this._playSound = false;

            // #506
            this._totalWinCountUp.visible = false;
            this._waysContainer.visible = false;
        }
        this._endSoundPlayed = false;

        this._countUpTimeline = gsap.timeline();

        if(this._winRatioConfig.duration == 0) {
            this._totalWinCountUp.getCountAnimation(this._totalWinAmount, this._totalWinAmount, this._winRatioConfig.duration);
            this._totalWinCountUp.scale.set(targetScale,targetScale);
            TrueGrit.keypadPlugin.setWin(TrueGrit.model.gameData.accumulatedRoundWin, true, this._isWinBelowStake);
            if(this._playSound) {
                this._endSoundPlayed = true;
                TrueGrit.soundPlayer.stopCountUp(this._winRatioConfig);
            }
        } else {
            if(this._playSound) {
                this._countUpTimeline.add(() => TrueGrit.soundPlayer.startCountUp());
            }
            this._countUpTimeline.add(this._totalWinCountUp.getCountAnimation(0, this._totalWinAmount, this._winRatioConfig.duration));
            this._countUpTimeline.add(gsap.to(this._totalWinCountUp.scale, {duration:this._winRatioConfig.duration ,x:targetScale,y:targetScale, ease:"power3.out"}), "<");
            this._countUpTimeline.add(() => {
                this._totalWinCountUp.stopAt(this._totalWinAmount);
                if(this._playSound) {
                    this._endSoundPlayed = true;
                    TrueGrit.soundPlayer.stopCountUp(this._winRatioConfig);
                }
            });
            this._countUpTimeline.add(() => TrueGrit.keypadPlugin.setWin(TrueGrit.model.gameData.accumulatedRoundWin, true, this._isWinBelowStake));
        }

        this._totalWinCountUp.alpha = 0;
        this._totalWaysWonText.text = waysWon.toString();
        this._totalWaysWonText.alpha = 0;
        this._totalWaysWonText.visible = true;

        if(waysWon < 2) {
            this._wayText.alpha = 0;
            this._wayText.visible = true;
            this._wayText.position.set(this._totalWaysWonText.position.x + this._totalWaysWonText.width, 6);
            this._waysText.position.set(this._totalWaysWonText.position.x + this._totalWaysWonText.width, 6);
        } else {
            this._waysText.alpha = 0;
            this._waysText.visible = true;
            this._wayText.position.set(this._totalWaysWonText.position.x + this._totalWaysWonText.width, 6);
            this._waysText.position.set(this._totalWaysWonText.position.x + this._totalWaysWonText.width, 6);
        }
        this._waysContainer.position.x = 360 - (this._waysContainer.width / 2);
        this._fadeInTimeline = gsap.timeline();
        this._fadeInTimeline.add([
            gsap.to(this._totalWinCountUp, {
                duration : TrueGritTotalWinView.FADE_IN_TIME,
                alpha : 1,
                ease : "power3.out"
            }),
            gsap.to(this._totalWaysWonText, {
                duration : TrueGritTotalWinView.FADE_IN_TIME,
                alpha : 1,
                ease : "power3.out"
            }),
            () => {
                if(this._waysText.visible) {
                    gsap.to(this._waysText, {
                        duration : TrueGritTotalWinView.FADE_IN_TIME,
                        alpha : 1,
                        ease : "power3.out"
                    });

                } else {
                    gsap.to(this._wayText, {
                        duration : TrueGritTotalWinView.FADE_IN_TIME,
                        alpha : 1,
                        ease : "power3.out"
                    });
                }
            }
        ]);

        if (this._countUpTimeline.totalDuration() === 0) {
            this._fadeInTimeline.add(() => this.fadeOutWinPres(0.5, 0), "+=0.5");
            this._countUpTimeline.add(() =>this.callCompleteFunction());
            return this._fadeInTimeline;
        } else {
            this._countUpTimeline.add(() => this.fadeOutWinPres(0.5, 0), "+=0.8");
            this._countUpTimeline.add(() =>this.callCompleteFunction());
            return this._countUpTimeline;
        }
    }

    private fadeOutWinPres(duration: number, delay: number): void {
        this._fadeOutTimeline = gsap.timeline({
            delay: delay
        });
        this._fadeOutTimeline.add([
            gsap.to(this._totalWinCountUp, {
                duration : duration,
                alpha : 0,
                ease : "power3.out"
            }),
            gsap.to(this._totalWaysWonText, {
                duration : duration,
                alpha : 0,
                ease : "power3.out"
            }),
            () => {
                if(this._waysText.visible) {
                    gsap.to(this._waysText, {
                        duration : duration,
                        alpha : 0,
                        ease : "power3.out"
                    });
                } else {
                    gsap.to(this._wayText, {
                        duration : duration,
                        alpha : 0,
                        ease : "power3.out"
                    });
                }
            }
        ]);

        this._fadeOutTimeline.add(() => {
            this._totalWinCountUp.visible = false;
            this._wayText.visible = false;
            this._waysText.visible = false;
            this._totalWaysWonText.visible = false;
        });

    }

    //If aborted by new spin
    public abort():void {
        if (this._countUpTimeline && this._countUpTimeline.isActive()) {
            this._countUpTimeline.pause();
            this._countUpTimeline.kill();

            TrueGrit.keypadPlugin.setWin(TrueGrit.model.gameData.accumulatedRoundWin, true, this._isWinBelowStake);

            this.setTotalWinForAbort();
            this.fadeOutWinPres(0.3, 0);

            if(this._playSound && !this._endSoundPlayed) {
                TrueGrit.soundPlayer.stopCountUp(this._winRatioConfig);
            }
        }
    }

    //If aborted by full screen clicking
    public hardAbort():void {
        if (this._fadeInTimeline && this._fadeInTimeline.isActive()) {
            this._fadeInTimeline.pause();
            this._fadeInTimeline.kill();

            this.setTotalWinForAbort();
            this.fadeOutWinPres(0.3, 0);
        }

        if (this._countUpTimeline && this._countUpTimeline.isActive()) {
            this._countUpTimeline.pause();
            this._countUpTimeline.kill();

            TrueGrit.keypadPlugin.setWin(TrueGrit.model.gameData.accumulatedRoundWin, true, this._isWinBelowStake);

            this.setTotalWinForAbort();
            this.fadeOutWinPres(0.5, 0.5);

            if (this._playSound && !this._endSoundPlayed) {
                this._endSoundPlayed = true;
                TrueGrit.soundPlayer.stopCountUp(this._winRatioConfig);
            }
        }

        this.callCompleteFunction();
    }


    private callCompleteFunction(){
        if (this._completeCallback) {
            this._completeCallback();
        }
    }

    private setTotalWinForAbort(): void {
        this._totalWinCountUp.alpha = 1;
        this._totalWinCountUp.scale.set(this._targetScale);
        this._totalWinCountUp.visible = true;
        this._totalWinCountUp.stopAt(this._totalWinAmount);
    }
}